import type { TBlueTable, TBlueObj } from "@app/types/insider";
import type { IFileItem } from "@app/types";
import type { TFileSysHead, TFileSysContent } from "@app/types/insider/fs";
import {
  epBuilderAnyIssuer,
  epBuilderAnyIssuerNoSlices,
} from "../routines/mapperfn-pathbuilder";

const FS_REPO_NAME = "fs";

export const fsRepo: TBlueObj<{ svn: IFileItem }> = {
  name: FS_REPO_NAME,
  initialState: {
    svn: {
      name: "root",
      size: 0,
      dateModified: new Date().toISOString(),
      thumbnail: "",
      isDirectory: true,
      items: [],
      roles: [], //'editor', 'viewer'
    },
  },
  starfx: true,
  idb: false,
  bootPriority: 0,
  // deprecated_since: 30
};

/* 		

filePath:"40754585/SWS1292/MOCANU_SI-SWS1292-15IAN2024_SUID4142472232DIUS_.xml"
isDirectory:false
size:3761 

*/

export const fileSysHead: TBlueTable<TFileSysHead> = {
  name: "fileSysHead",
  empty: {} as TFileSysHead,
  initialState: {},
  primaryKey: "FFS_ID",
  starfx: true,
  starfx_index: "FFS_ID",
  apiUrl: "/select/ss_filesys_head_range",
  pkeyUrl: "/select/ss_filesys_head_pkey",
  urlPathBuilder: epBuilderAnyIssuer,
  idb: true,
  idb_indexes: [
    // { name: 'byHash', keyPath: ['_hkey', '_hvalue'] },
    { name: "headByFXMCreData", keyPath: "FXM_QDATA" },
    // { name: 'shid0', keyPath: 'shid0' },
  ],
  bootPriority: 2,
  onmru: "new",
  oncsdb: "full",
  label: "Sistem de fisiere",
  appContext: ["CtxPersonalKarma", "CtxJurnalCorporate"],
};

export const fileSysContent: TBlueTable<TFileSysContent> = {
  name: "fileSysContent",
  empty: {} as TFileSysContent,
  initialState: {},
  apiUrl: "/select/ss_filesys_content_range",
  pkeyUrl: "/select/ss_filesys_content_pkey",
  primaryKey: "FFC_ID",
  urlPathBuilder: epBuilderAnyIssuer,
  starfx: true,
  starfx_index: "FFC_ID",
  idb: true,
  idb_indexes: [
    // { name: 'byHash', keyPath: ['_hkey', '_hvalue'] },
    { name: "contentByFXMCreData", keyPath: "FXM_QDATA" },
    // { name: 'shid0', keyPath: 'shid0' },
  ],
  bootPriority: 2,
  onmru: "new",
  oncsdb: "full",
  label: "Sistem de fisiere",
  appContext: ["CtxPersonalKarma", "CtxJurnalCorporate"],
};

export const fileSysLocalDisk: TBlueTable<Record<string, IFileItem>> = {
  name: "fileSysLocalDisk",
  empty: {} as Record<string, IFileItem>,
  initialState: {},
  primaryKey: "FXM_ID", // fn:  `FXM_ID::${FXM_ID}`;
  starfx: true,
  starfx_index: "FXM_ID",
  idb: true,
  idb_indexes: [
    // { name: 'byHash', keyPath: ['_hkey', '_hvalue'] },
    // { name: 'shid0', keyPath: 'shid0' },
  ],
  apiUrl: null,
  // `/efactura/read_dir_of_dowcode?`, //different then the others
  bootPriority: -1,
  onmru: "no",
  oncsdb: "no",
  label: "Sistem de fisiere",
  appContext: [],
};

interface FFile {
  filePath: string;
  isDirectory: boolean;
  size?: number; // Size is optional as directories might not have a 'size'
  type?: string; // Type (e.g., 'xml', 'pdf') is optional and mainly relevant for files
}

interface FDirectory {
  [invoiceSerial: string]: FFile[];
}

interface FStore {
  [cif: string]: FDirectory;
}

export const fsDirTree: TBlueObj<FStore> = {
  name: "fsDirTree",
  initialState: {},
  starfx: true,
  idb: true,
  bootPriority: 2,
};
